var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-card",
        {
          staticStyle: {
            "border-left": "0",
            "border-right": "0",
            "border-top": "0",
          },
        },
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { sm: "5" } }, [
                _c(
                  "h4",
                  {
                    staticClass: "card-title mb-0",
                    attrs: { id: "chart-portfolio-vulns" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.component_vulnerabilities")) +
                        "\n        "
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "small text-muted" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.last_measurement")) +
                        ": " +
                        _vm._s(_vm.lastMeasurement)
                    ),
                    _c(
                      "b-link",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: "PORTFOLIO_MANAGEMENT",
                            expression: "'PORTFOLIO_MANAGEMENT'",
                          },
                        ],
                        staticClass: "font-weight-bold",
                        staticStyle: { "margin-left": "6px" },
                        on: { click: _vm.refreshMetrics },
                      },
                      [_c("i", { staticClass: "fa fa-refresh" })]
                    ),
                  ],
                  1
                ),
              ]),
              _c("b-col", {
                staticClass: "d-none d-md-block",
                attrs: { sm: "7" },
              }),
            ],
            1
          ),
          _c("chart-portfolio-vulnerabilities", {
            ref: "chartComponentVulnerabilities",
            staticClass: "chart-wrapper",
            staticStyle: { height: "200px", "margin-top": "40px" },
            attrs: { chartId: "chartComponentVulnerabilities", height: 200 },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", lg: "4" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { sm: "6" } },
                            [
                              _c(
                                "Callout",
                                { attrs: { variant: "severity-critical" } },
                                [
                                  _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(_vm._s(_vm.$t("severity.critical"))),
                                  ]),
                                  _c("br"),
                                  _c("strong", { staticClass: "h4" }, [
                                    _vm._v(_vm._s(_vm.currentCritical)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { sm: "6" } },
                            [
                              _c(
                                "Callout",
                                { attrs: { variant: "severity-high" } },
                                [
                                  _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(_vm._s(_vm.$t("severity.high"))),
                                  ]),
                                  _c("br"),
                                  _c("strong", { staticClass: "h4" }, [
                                    _vm._v(_vm._s(_vm.currentHigh)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", lg: "4" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { sm: "6" } },
                            [
                              _c(
                                "Callout",
                                { attrs: { variant: "severity-medium" } },
                                [
                                  _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(_vm._s(_vm.$t("severity.medium"))),
                                  ]),
                                  _c("br"),
                                  _c("strong", { staticClass: "h4" }, [
                                    _vm._v(_vm._s(_vm.currentMedium)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { sm: "6" } },
                            [
                              _c(
                                "Callout",
                                { attrs: { variant: "severity-low" } },
                                [
                                  _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(_vm._s(_vm.$t("severity.low"))),
                                  ]),
                                  _c("br"),
                                  _c("strong", { staticClass: "h5" }, [
                                    _vm._v(_vm._s(_vm.currentLow)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", lg: "4" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { sm: "6" } },
                            [
                              _c(
                                "Callout",
                                { attrs: { variant: "severity-unassigned" } },
                                [
                                  _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("severity.unassigned"))
                                    ),
                                  ]),
                                  _c("br"),
                                  _c("strong", { staticClass: "h4" }, [
                                    _vm._v(_vm._s(_vm.currentUnassigned)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { sm: "6" } },
                            [
                              _c(
                                "Callout",
                                { attrs: { variant: "severity-info" } },
                                [
                                  _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("message.risk_score"))
                                    ),
                                  ]),
                                  _c("br"),
                                  _c("strong", { staticClass: "h5" }, [
                                    _vm._v(_vm._s(_vm.currentRiskScore)),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "6" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { sm: "5" } }, [
                        _c(
                          "h4",
                          {
                            staticClass: "card-title mb-0",
                            attrs: { id: "chart-policy-violations" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("message.policy_violations")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "small text-muted" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("message.policy_violations_by_state")
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _c("b-col", {
                        staticClass: "d-none d-md-block",
                        attrs: { sm: "7" },
                      }),
                    ],
                    1
                  ),
                  _c("chart-policy-violations-state", {
                    ref: "chartPolicyViolationsState",
                    staticClass: "chart-wrapper",
                    staticStyle: { height: "200px", "margin-top": "40px" },
                    attrs: {
                      chartId: "chartPolicyViolationsState",
                      height: 200,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { sm: "6" } },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { sm: "5" } }, [
                        _c(
                          "h4",
                          {
                            staticClass: "card-title mb-0",
                            attrs: { id: "chart-policy-violation-breakdown" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("message.policy_violations")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "small text-muted" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "message.policy_violations_by_classification"
                                )
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                      _c("b-col", {
                        staticClass: "d-none d-md-block",
                        attrs: { sm: "7" },
                      }),
                    ],
                    1
                  ),
                  _c("chart-policy-violation-breakdown", {
                    ref: "chartPolicyViolationBreakdown",
                    staticClass: "chart-wrapper",
                    staticStyle: { height: "200px", "margin-top": "40px" },
                    attrs: {
                      chartId: "chartPolicyViolationBreakdown",
                      height: 200,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }